export default __webpack_public_path__ + "static/media/mini-icon-analytics-inactive.003cc0d6.svg";